import { Controller } from '@hotwired/stimulus';
import axios from 'axios';

export default class extends Controller {
  static values = {
    eventLabel: String,
    companyId: String
  }

  connect() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
    axios.post('/member_company_event_stats', {
      event_label: this.eventLabelValue,
      company_id: this.companyIdValue
    });
  }
}